import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import usePreAuthorizedAmounts from 'hooks/usePreAuthorizedAmounts';

import { arePreApprovedPricesHidden, getCurrencyIsoCode } from 'modules/selfServices/selectors';

import PreAutorizedAmountLine from 'components/RepairOrder/PreAutorizedAmountLine';
import List, { ListProps } from './List';

const RepairOrderList: React.FC<Pick<ListProps, 'items'>> = ({ items }) => {
  const currencyIsoCode = useSelector(getCurrencyIsoCode);
  const hidePreApprovedWorksPrices = useSelector(arePreApprovedPricesHidden);

  const { customerPreAuthorizedAmount, hasCustomerPreAuthorizedAmount } = usePreAuthorizedAmounts();
  const hideTotals = hasCustomerPreAuthorizedAmount && hidePreApprovedWorksPrices;

  return (
    <>
      <List
        items={items}
        showHiddenPriceWarning
        hideTotals={hideTotals}
        title={<FormattedMessage id="basket.total.workOrder" defaultMessage="Planned works" />}
      />
      {hasCustomerPreAuthorizedAmount && (
        <PreAutorizedAmountLine
          currencyIsoCode={currencyIsoCode}
          amount={customerPreAuthorizedAmount}
          className="flex justify-between items-center text-lowest [&>span]:text-xs font-medium pl-2"
        />
      )}
    </>
  );
};

export default RepairOrderList;
